import { render, staticRenderFns } from "./TypicalCases.vue?vue&type=template&id=cd2a416c&scoped=true&"
import script from "./TypicalCases.vue?vue&type=script&lang=js&"
export * from "./TypicalCases.vue?vue&type=script&lang=js&"
import style0 from "./TypicalCases.vue?vue&type=style&index=0&id=cd2a416c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2a416c",
  null
  
)

export default component.exports